/**
 * Diagnosis Service
 * Patient diagnosis tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RuleOutDiagnosisRequestDto { 
    /**
     * Reason for ruling out the diagnosis
     */
    reason: RuleOutDiagnosisRequestDto.ReasonEnum;
    /**
     * Additional reasoning for ruling out
     */
    reasoning?: string;
}
export namespace RuleOutDiagnosisRequestDto {
    export type ReasonEnum = 'negative_test_results' | 'incompatible_symptoms' | 'alternative_diagnosis_confirmed' | 'clinical_assessment' | 'patient_history' | 'other';
    export const ReasonEnum = {
        NegativeTestResults: 'negative_test_results' as ReasonEnum,
        IncompatibleSymptoms: 'incompatible_symptoms' as ReasonEnum,
        AlternativeDiagnosisConfirmed: 'alternative_diagnosis_confirmed' as ReasonEnum,
        ClinicalAssessment: 'clinical_assessment' as ReasonEnum,
        PatientHistory: 'patient_history' as ReasonEnum,
        Other: 'other' as ReasonEnum
    };
}


